import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { VideoPreloader } from '../VideoPreloader/VideoPreloader';
import ErrorView from './components/ErrorView';
import { doSmthOnRenderError } from './utils';

interface QueryBoundariesProps {
  children: React.ReactNode;
}

export const QueryBoundaries = ({ children }: QueryBoundariesProps) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary onReset={reset} FallbackComponent={ErrorView} onError={doSmthOnRenderError}>
        <React.Suspense fallback={<VideoPreloader />}>{children}</React.Suspense>
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
);
